import { Api } from '../api';
import { resource } from '../endpoints';
import type { GetProductImageInfoResponse } from './models';

export class ResourceApi extends Api {
  static getFooterContent = () => this.get<[]>({ url: resource.getFooterContent() });

  static getProductImageInfo = (name: string) => this.get<GetProductImageInfoResponse[]>({ url: resource.getProductImageInfo(name) });

  static getProductImage = (name: string) => this.get<Blob>({ url: resource.getProductImage(name) });

  static getTC = (productName: string) => this.get<any>({ url: resource.getTC(productName) });
}
